import BaseAPIConfig from "@/apis/base/BaseAPIConfig.js";

export default class BaseAPI {
  constructor() { }

  /**
   * Tên controller
   */
  controller = "";

  /**
   * Hàm gọi phương thức get
   * created by CVCUONG1 17/12/2020
   */
  get(route) {
    return BaseAPIConfig.get(this.controller + route);
  }

  /**
   * Hàm gọi phương thức post
   * created by CVCUONG1 21/12/2020
   */
  post(route, data) {
    return BaseAPIConfig.post(this.controller + route, data);
  }

  /**
   * Hàm gọi phương thức get
   * created by CVCUONG1 17/12/2020
   */
  getFileApi(data) {
    return BaseAPIConfig.get(`${this.controller}/${data}/`);
  }

  /**
   * Hàm lấy tất cả dữ liệu
   * created by pdthien 07.12.2020
   */
  getAll(pagingRequest = null) {
    return BaseAPIConfig.post(this.controller + "/getAll", pagingRequest ? pagingRequest : {});
  }

  /**
   * Hàm lấy tất cả dữ liệu
   * created by pdthien 07.12.2020
   */
  getAllWithPath(path) {
    return BaseAPIConfig.post(`${this.controller}/${path}`, {});
  }

  /**
   * Hàm lấy dữ liệu theo ID
   * created by pdthien 07.12.2020
   */
  getByID(id) {
    return BaseAPIConfig.get(`${this.controller}?id=${id}`);
  }

  /**
   * Hàm lấy dữ liệu theo ID
   * created by pdthien 07.12.2020
   */
  getByIDWithPath(path) {
    return BaseAPIConfig.get(`${this.controller}/${path}`);
  }

  /**
   * Hàm xóa base
   * @param {*} id
   * created by nhviet 07.12.2020
   */
  deleteDataByID(id) {
    return BaseAPIConfig.delete(`${this.controller}/deleteDataByID/${id}`);
  }

  /**
   * Hàm xóa theo ID
   * @param {*} id
   * created by pdthien 07.12.2020
   */
  deleteByIDWithPath(path) {
    return BaseAPIConfig.delete(`${this.controller}/${path}`);
  }

  /**
   * Hàm lưu dữ liệu
   * @param {*} data
   * created by pdthien 07.12.2020
   */
  save(data) {
    return BaseAPIConfig.post(`${this.controller}/save`, data);
  }

  /**
   * Hàm lưu dữ liệu
   * @param {*} data
   * created by pdthien 07.12.2020
   */
  saveWithPath(path, data) {
    return BaseAPIConfig.post(`${this.controller}/${path}`, data);
  }

  /**
   * Hàm lưu list dữ liệu
   * @param {*} data
   * created by pdthien 07.12.2020
   */
  saveList(data) {
    return BaseAPIConfig.post(`${this.controller}/save-list`, data);
  }

  /**
   * Hàm lưu list dữ liệu async
   * @param {*} data
   * created by cvcuong1 02.3.2021
   */
  saveListAsync(data) {
    return BaseAPIConfig.post(`${this.controller}/save-list-async`, data);
  }

  /**
   * Hàm lưu list dữ liệu
   * @param {*} data
   * created by pdthien 07.12.2020
   */
  saveListWithPath(path, data) {
    return BaseAPIConfig.post(`${this.controller}/${path}`, data);
  }

  /**
   * Hàm xóa theo List ID
   * @param {*} lstID
   */
  deleteByListID(lstID) {
    return BaseAPIConfig.delete(`${this.controller}/deleteByListID`, {
      data: lstID
    });
  }

  /**
   * Hàm xóa theo List ID
   * @param {*} lstID
   * updated by PHQuan 29/12/2020
   */
  deleteByListIDWithPath(path, lstID) {
    return BaseAPIConfig.delete(`${this.controller}/${path}`, { data: lstID });
  }

  /**
   * save async
   * created by PVTHONG 14.12.2020
   */
  saveAsync(payload) {
    return BaseAPIConfig.post(`${this.controller}`, payload);
  }

  /**
   * Hàm lấy dữ liệu phân trang
   * @param {*} data
   * created by pqmai 15/12/2020
   */
  getPaging(data) {
    return BaseAPIConfig.post(`${this.controller}/paging`, data);
  }

  /**
   * Hàm lấy dữ liệu phân trang
   * @param {*} data
   * creetedby cvcuong1
   */
  paging(pagingRequest) {
    return BaseAPIConfig.post(`${this.controller}/paging`, pagingRequest);
  }

  /**
   * Hàm lấy dữ liệu phân trang
   * @param {*} data
   * creetedby dthan
   */
  pagingWithPath(path, pagingRequest) {
    return BaseAPIConfig.post(`${this.controller}/${path}`, pagingRequest);
  }

  /**
   * Lấy data theo ID
   * created by PVTHONG 29.12.2020
   */
  getFormData(id) {
    return BaseAPIConfig.get(`${this.controller}/form-data/${id}`);
  }

  /**
   * Hàm cập nhật 1 trường
   * created by nttung3 16.12.2020
   */
  updateField(dataUpdate) {
    return BaseAPIConfig.post(`${this.controller}/update-field`, dataUpdate);
  }

  /**
   * Hàm cập nhật một trường async
   * Created by CVCUONG1 - 15/3/2021
   */
  updateFieldAsync(data) {
    return BaseAPIConfig.post(`${this.controller}/update-fieldasync`, data);
  }

  updateSummarySetting(data) {
    return BaseAPIConfig.post(`${this.controller}/update-summary-setting`, data);
  }
}
